<template>
  <div>
    <filter-slot
      :filter="filters"
      :filterPrincipal="filterPrincipal"
      :paginate="paginate"
      @reload="$refs['ref-table-monitoring-detail-report'].refresh()"
    >
      <template #table>
        <b-table
          ref="ref-table-monitoring-detail-report"
          :per-page="paginate.perPage"
          :current-page="paginate.currentPage"
          sticky-header="50vh"
          small
          class="position-relative"
          table-class="text-nowrap"
          :busy.sync="isBusy"
          :items="myProvider"
          :fields="showFields"
        >
          <template #table-busy>
            <b-skeleton-table
              :headers="fields"
              :rows="paginate.perPage"
              :columns="fields.length"
              :table-props="{ bordered: true, striped: true }"
            />
          </template>
          <template #cell(code)="data">
            <div class="d-flex">
              <div class="pt-1">
                <feather-icon
                  v-if="data.item.personal_type == 'Driver'"
                  icon="TruckIcon"
                  size="22"
                  class="text-warning"
                />
                <feather-icon
                  v-else
                  icon="UserIcon"
                  size="22"
                  class="text-success"
                />
              </div>
              <div class="ml-1">
                <span> {{ data.item.personal_name | capitalize }} </span>
                <br />
                <span style="opacity: 0.5"> #{{ data.item.code }} </span>
              </div>
            </div>
          </template>

          <template #cell(ut_type)="data">
            <span v-if="data.value">
              {{ ut_types.find((x) => x.id == data.value).value }}
            </span>
            <span v-else> - </span>
          </template>

          <template #cell(status)="data">
            <b-badge
              pill
              :variant="`light-${
                data.value == 'Active' ? 'success' : 'danger'
              }`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(is_viatic)="data">
            <b-badge
              pill
              :variant="`light-${data.value == 'Apply' ? 'success' : 'danger'}`"
            >
              <span>{{ $t(data.value) | capitalize }}</span>
            </b-badge>
          </template>
          <template #cell(entity_group_name)="data">
            <span> {{ data.value | capitalize }} </span>
          </template>
          <template #cell(attendance_status)="data">
            <b-badge
              pill
              :variant="`light-${data.value == 1 ? 'success' : 'danger'}`"
            >
              <span>{{
                (data.value == 1 ? $t("Active") : $t("Inactive")) | capitalize
              }}</span>
            </b-badge>
          </template>
          <template #cell(abbreviation)="data">
            <b-badge
              pill
              :variant="`light-${homeworkStatusVariant(
                data.item.homework_status_id
              )}`"
              :class="{ 'cursor-pointer': data.item.to_day != null }"
            >
              <span>
                {{ data.item.abbreviation }} -
                {{ data.item.date | globalDate }}</span
              >
            </b-badge>
          </template>
          <template #cell(observation)="data">
            <read-more
              v-if="data.value != 'null' && data.value != null"
              class="text-uppercase"
              :more-str="$t('read more ...')"
              :less-str="$t('read less ...')"
              :text="data.value"
              link="#"
              :max-chars="25"
            ></read-more>
          </template>
          <template #cell(comment)="data">
            <span>
              {{ (data.value == "null" ? "" : data.value) | capitalize }}
            </span>
          </template>
          <template #cell(created_by)="data">
            <span> {{ data.item.created_by | capitalize }} </span><br />
            <span style="opacity: 0.5">
              {{ data.item.created_at | globalDate }}
            </span>
          </template>
        </b-table>
      </template>
    </filter-slot>

    <AttendanceDetailsByStatus
      v-if="attendanceDetailsByStatus"
      :dataModal="dataModal"
      @hideModal="hideAttendanceDetailsByStatus"
    />

    <PersonalAttendance
      v-if="personalAttendance"
      :dataModal="dataModal"
      @hideModal="hidePersonalAttendance"
    />

    <!-- <b-button @click="process">Process</b-button>
    <b-button @click="send">Send</b-button>
    <pre>
      {{ items }}
    </pre> -->
    <!-- <b-table :items="items" small responsive> </b-table> -->
  </div>
</template>

<script>
/* COMPONENTS */
import FilterSlot from "@/views/commons/filter-slot/FilterSlot.vue";

/* DATA */
import Filters from "@/views/monitoring/views/reports/data/filters.data.js";
import Fields from "@/views/monitoring/views/reports/data/fields.data.js";

/* Modals */
import AttendanceDetailsByStatus from "@/views/monitoring/views/attendance/components/modals/AttendanceDetailsByStatus.vue";
import PersonalAttendance from "@/views/monitoring/views/attendance/components/modals/PersonalAttendance.vue";

/* Services */
import AttendanceService from "@/views/monitoring/views/attendance/services/attendance.service.js";
import ReportsService from "@/views/monitoring/views/reports/services/reports.service.js";
import EmployeeService from "@/views/rrhh/views/employees/services/employee.service.js";
import { mapGetters } from "vuex";

export default {
  components: {
    FilterSlot,
    AttendanceDetailsByStatus,
    PersonalAttendance,
  },
  data() {
    return {
      ut_types: [
        { id: 1, value: "Camion Carreta" },
        { id: 2, value: "C - Camión" },
        { id: 3, value: "TS - Tracto Semiremolque" },
        { id: 4, value: "CR - Camión Remolque" },
      ],
      filters: [...Filters],
      // items: Usuarios,
      params: 1,
      fields: [...Fields],
      isBusy: false,
      filterPrincipal: {
        type: "input",
        inputType: "text",
        placeholder: "Search...",
        model: "",
      },
      paginate: {
        from: 0,
        to: 0,
        of: 0,
        perPage: 10,
        currentPage: 1,
      },
      attendanceDetailsByStatus: false,
      personalAttendance: false,
      dataModal: {},
    };
  },
  computed: {
    showFields() {
      //   return Fields.map(item => ({ ...item, label: this.$t(item.label) }));
      this.fields[0].variant = this.isDarkSkin ? "dark" : "light";
      return this.fields.filter((item) => item.visible);
    },
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),
  },
  created() {
    this.restaureFields();
    this.restaureFilters();
    this.getEntityGroups();
  },
  methods: {
    restaureFilters() {
      this.filters[0].cols = 6;
      this.filters[0].label = "From";
      this.filters[1].visible = true;
      this.filters[6].visible = true;
      this.filters[5].cols = 6;
    },
    restaureFields() {
      this.fields.map((item) => (item.visible = true));
      this.fields[5].visible = false;
      this.fields[2].visible = false;
    },
    async myProvider(ctx) {
      try {
        this.addPreloader();
        const params = {
          page: ctx.currentPage,
          perpage: ctx.perPage,
          search_txt: this.filterPrincipal.model,
          from: this.filters[0].model,
          to: this.filters[1].model,
          personal_type: this.filters[2].model,
          is_viatic: this.filters[3].model,
          entity_group_id: this.filters[4].model,
          status: this.filters[5].model != null ? this.filters[5].model : 1,
          attendance_status: this.filters[6].model,
        };
        const { data } = await ReportsService.getDetailedAttendanceReport(
          params
        );
        this.paginate.from = data.from;
        this.paginate.to = data.to;
        this.paginate.of = data.total;
        this.paginate.perPage = data.per_page;
        this.paginate.currentPage = data.current_page;
        return data.data;
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
    async getEntityGroups() {
      const { data } = await EmployeeService.getEntitiesGroup();
      this.filters[4].options = data;
    },
    homeworkStatusVariant(homework_status_id) {
      if (homework_status_id == null) return "default";
      if (homework_status_id === 3) return "danger";
      if (homework_status_id === 4) return "warning";
      if (homework_status_id === 1 || homework_status_id === 2)
        return "success";
      if (homework_status_id === "inactive") return "secondary";
      return "primary";
    },
    countHomeworkStatusVariant(count) {
      if (count === 0) return "success";
      if (count > 0 && count <= 3) return "warning";
      return "danger";
    },
    todayRecord(attendance_id, today, item) {
      this.dataModal = {
        attendance_id,
        personal_name: item.personal_name,
        code: item.code,
        today,
      };
      this.attendanceDetailsByStatus = true;
    },
    getAttendanceDetailsByStatus(
      attendance_id,
      homework_status_id,
      count,
      item
    ) {
      if (count == 0) return;
      this.dataModal = {
        attendance_id,
        homework_status_id,
        personal_name: item.personal_name,
        code: item.code,
      };
      this.attendanceDetailsByStatus = true;
    },
    hideAttendanceDetailsByStatus() {
      this.attendanceDetailsByStatus = false;
    },
    setAttendance(item) {
      this.dataModal = item;
      this.dataModal.origin = "attendance";
      this.personalAttendance = true;
    },
    hidePersonalAttendance(action = false) {
      if (action == true) {
        this.$refs["ref-table-monitoring-detail-report"].refresh();
      }
      this.personalAttendance = false;
    },
  },
};
</script>

<style>
</style>